import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, throwError, TimeoutError } from 'rxjs';
import { map, take, timeout, catchError, filter } from 'rxjs/operators';
import { ResponseIdNamePairs } from '../../models/claims/individual.model';
import * as CommonFunction from '../../services/common.function';
import { add } from 'ngx-bootstrap/chronos';
@Injectable({
  providedIn: 'root'
})
export class ClaimsmonitorService {
  loCurrentUserData: any;
  constructor(private http: HttpClient) {
    this.loCurrentUserData = JSON.parse(localStorage.getItem('currentUserData') || '{}');
  }

  getMonitorIdNamePairs(): Observable<any> {
    return this.http.get(environment.WebApiURL + 'api/ClaimMonitor/getMonitorIdNamePairs');
  }

  getReportType(): Observable<any> {
    return this.http.get(environment.WebApiURL + 'api/ClaimMonitor/getReportType');
  }

  getPhysicalLimitation(): Observable<any> {
    return this.http.get(environment.WebApiURL + 'api/ClaimMonitor/getPhysicalLimitation');
  }

  /** Shared JSON body for generateClaims and link-out submit (same shape). */
  private buildClaimSubmissionBody(data: any): any {
    const body: any = {
      uiClientId: data.uiClientId,
      uiTeamId: data.uiTeamId,
      isBatch: data.isBatch,
      stSubmissionFileName: data.stSubmissionFileName,
      stBatchName: data.stBatchName ?? 'NULL',
      uiCreatedBy: data.uiCreatedBy,
      stTimeZone: data.stTimeZone,
      lstClaimRequestSubmissions: data.lstClaimRequestSubmissions,
      fFaceImage: data.fFaceImage,
    };
    if (data.correlationId != null && String(data.correlationId).trim() !== '') {
      body.stCorrelationId = String(data.correlationId).trim();
    }
    return body;
  }

  addIndividualClaim(data: any): Observable<any> {
    const body = this.buildClaimSubmissionBody(data);
    return this.http.post(environment.WebApiURL + 'api/ClaimMonitor/generateClaims', body).pipe(
      map((response: any) => response.data)
    );
  }

  /** Link-out submit — only used when LINKOUT_FEATURE_ENABLED (see addnew-claims formSubmit). */
  linkoutSubmit(data: any): Observable<any> {
    const body = this.buildClaimSubmissionBody(data);
    return this.http.post(environment.WebApiURL + 'api/linkout/submit', body).pipe(
      map((response: any) => response.data)
    );
  }

  updateClaim(updatedClaim: any): Observable<any> {
    const loFormdata: FormData = new FormData();
    loFormdata.append('inClaimMonitorId', updatedClaim.inClaimMonitorId);
    loFormdata.append('inClaimIterationId', updatedClaim.inClaimIterationId);
    loFormdata.append('fFaceImage', updatedClaim.fFaceImage);
    loFormdata.append('uiClientId', updatedClaim.uiClientId);
    loFormdata.append('uiTeamId', updatedClaim.uiTeamId);
    loFormdata.append('stFirstName', updatedClaim.stFirstName);
    loFormdata.append('stLastName', updatedClaim.stLastName);
    loFormdata.append('inBirthYear', updatedClaim.inBirthYear);
    loFormdata.append('stAddress', updatedClaim.stAddress);
    loFormdata.append('stZipCode', updatedClaim.stZipCode);
    loFormdata.append('phoneNo', updatedClaim.phoneNo);
    loFormdata.append('stEmail', updatedClaim.stEmail);
    loFormdata.append('stGender', updatedClaim.stGender);
    loFormdata.append('stCompanyName', updatedClaim.stCompanyName);
    loFormdata.append('stOccupation', updatedClaim.stOccupation);
    loFormdata.append('inPhysicalLimitationId', updatedClaim.inPhysicalLimitationId);
    loFormdata.append('dtClaimFile', updatedClaim.dtClaimFile);
    loFormdata.append('dtDateofBirth', updatedClaim.dtDateofBirth);
    loFormdata.append('stKnownAs', updatedClaim.stKnownAs);
    loFormdata.append('stKeywords', updatedClaim.stKeywords);
    loFormdata.append('stLinkAnalysis', updatedClaim.stLinkAnalysis);
    loFormdata.append('uiUpdatedBy', updatedClaim.uiUpdatedBy);
    loFormdata.append('stReferenceId', updatedClaim.stReferenceId);
    loFormdata.append('stNotes', updatedClaim.stNotes);
    loFormdata.append('stFaceImage', updatedClaim.stFaceImage);
    loFormdata.append('inPhysicalLimitationId', updatedClaim.stFaceImage);
    loFormdata.append('lstUpdateClaimRequestSubmission', JSON.stringify(updatedClaim.lstUpdateClaimRequestSubmission)); 
    loFormdata.append('stLicensePlate', updatedClaim.stLicensePlate);
    loFormdata.append('stState', updatedClaim.stState);    
    loFormdata.append('stAdditionalAddress', updatedClaim.stAdditionalAddress ?? '');
    return this.http.post(environment.WebApiURL + 'api/ClaimMonitor/UpdateClaim', loFormdata).pipe(map((response: any) => {
      return response
    }));
  }

  getClaimMonitorDetails(body: any): Observable<any> {
    return this.http.post(`${environment.WebApiURL}api/ClaimMonitor/getClaimMonitorDetails`, body).pipe(map((response: any) => {
      return response
    }));
  }

  getClaimMonitorDetailsFinalCount(body: any): Observable<any> {
    return this.http.post(`${environment.WebApiURL}api/ClaimMonitor/getClaimMonitorDetailsFinalCount`, body).pipe(map((response: any) => {
      return response
    }));
  }

  getUserIdNamePairs(uiClientId: string): Observable<ResponseIdNamePairs> {
    const httpOptions = {
      params: { 'uiClientId': uiClientId }
    };
    return this.http.get(`${environment.WebApiURL}api/history/getUserIdNamePairs`, httpOptions).pipe(map((response: any) => {
      return response;
    }));
  }

  getClaimMonitorDetailsById(inClaimMonitorId: any, inClaimIterationId: any = 0): Observable<any> {
    let stTimeZone = CommonFunction.GetTimeZone();
    return this.http.get(`${environment.WebApiURL}api/ClaimMonitor/getClaimMonitorDetailsById?inClaimMonitorId=${inClaimMonitorId}&inClaimIterationId=${inClaimIterationId}&stTimeZone=${stTimeZone}`).pipe(map((response: any) => {
      return response.data
    }));
  }

  getClaimMonitorDetailsByIdAndPublishDate(inClaimMonitorId: any, inClaimIterationId: any = 0,publishGroup:any): Observable<any> {
    let stTimeZone = CommonFunction.GetTimeZone();
    return this.http.get(`${environment.WebApiURL}api/ClaimMonitor/getClaimMonitorDetailsByIdAndPublishDate?inClaimMonitorId=${inClaimMonitorId}&inClaimIterationId=${inClaimIterationId}&stTimeZone=${stTimeZone}&publishGroup=${publishGroup}`).pipe(map((response: any) => {
      return response.data
    }));
  }

  getClaimMonitorDetailsReviewById(inClaimMonitorId: any, inClaimIterationId: any = 0): Observable<any> {
    let stTimeZone = CommonFunction.GetTimeZone();
    return this.http.get(`${environment.WebApiURL}api/ClaimMonitor/getClaimMonitorDetailsReviewById?inClaimMonitorId=${inClaimMonitorId}&inClaimIterationId=${inClaimIterationId}&stTimeZone=${stTimeZone}`).pipe(map((response: any) => {
      return response.data
    }));
  }

getClaimTimeLinePublishCount(
  inClaimMonitorId: any,
  inClaimIterationId: any = 0
): Observable<any> {
  let stTimeZone = CommonFunction.GetTimeZone();
  return this.http
    .get(
      `${environment.WebApiURL}api/ClaimMonitor/getClaimTimeLinePublishCount?inClaimMonitorId=${inClaimMonitorId}&inClaimIterationId=${inClaimIterationId}&stTimeZone=${stTimeZone}`
    )
    .pipe(map((response: any) => {
      return response?.data; // { Count: number }
    }));
}


  getClaimMonitorDetailsReviewByPublishDateAndId(PublishGroup: any, inClaimMonitorId: any, inClaimIterationId: any = 0): Observable<any> {
    let stTimeZone = CommonFunction.GetTimeZone();
    return this.http.get(`${environment.WebApiURL}api/ClaimMonitor/getClaimMonitorDetailsReviewByPublishDateAndId?PublishGroup=${PublishGroup}&inClaimMonitorId=${inClaimMonitorId}&inClaimIterationId=${inClaimIterationId}&stTimeZone=${stTimeZone}`).pipe(map((response: any) => {
      return response.data
    }));
  }

  releaseMachineReview(inClaimMonitorId: string, inClaimIterationId: string): Observable<any>{
    const body: any = {
      inClaimMonitorId: inClaimMonitorId,
      inClaimIterationId: inClaimIterationId
    }
    return this.http.post(`${environment.WebApiURL}api/ClaimMonitor/releaseMachineReview`, body).pipe(map((response: any) => {
      return response
    }));
  }

   humanReviewRequired(inClaimMonitorId: string, inClaimIterationId: string, inGroupNo: number): Observable<any>{
    let stTimeZone = CommonFunction.GetTimeZone();
    const body: any = {
      inClaimMonitorId: inClaimMonitorId,
      inClaimIterationId: inClaimIterationId,
      inGroupNo: inGroupNo,
      stTimeZone: stTimeZone
    }
    return this.http.post(`${environment.WebApiURL}api/ClaimMonitor/humanReviewRequired`, body).pipe(map((response: any) => {
      return response
    }));
  }
   
  generateInvoice(invoiceId: string): Observable<Blob> {
  return this.http.get(
    `${environment.WebApiURL}api/ClaimMonitor/getInvoice/${invoiceId}`,
    { responseType: 'blob' }
  );
  }

  downloadFile(checkedIds: any, claimIterationIds : any, isPreview : any, selectedVal : any, objClaimPublish:any) {
    let stTimeZone = CommonFunction.GetTimeZone();
    const body: any = {
      stClaimMonitorIds: checkedIds,
      stClaimIterationIds: claimIterationIds,
      stTimeZone: stTimeZone,
      isPreview: isPreview,
      stFileType: selectedVal,
      stClaimIdGroupId: objClaimPublish
    }
    return this.http.post(environment.WebApiURL + 'api/ClaimMonitor/downloadClaimFile', body);
  }

  downloadInvoice(checkedIds: any, claimIterationIds : any, isPreview : any, selectedVal : any, objClaimPublish:any) {
    let stTimeZone = CommonFunction.GetTimeZone();
    const body: any = {
      stClaimMonitorIds: checkedIds,
      stClaimIterationIds: claimIterationIds,
      stTimeZone: stTimeZone,
      isPreview: isPreview,
      stFileType: selectedVal,
      stClaimIdGroupId: objClaimPublish
    }
    return this.http.post(environment.WebApiURL + 'api/ClaimMonitor/downloadInvoiceFile', body);
  }


  copyDownloadFile(checkedIds: any, claimIterationIds: any, isPreview: any, selectedVal: any, objClaimPublish: any) {
  const body: any = {
    stClaimMonitorIds: checkedIds,
    stClaimIterationIds: claimIterationIds,
    stTimeZone: CommonFunction.GetTimeZone(),
    isPreview: isPreview,
    stFileType: selectedVal,
    stClaimIdGroupId: objClaimPublish
  };

  return this.http.post(
    environment.WebApiURL + 'api/ClaimMonitor/copyDownloadClaimFile',
    body,
    { responseType: 'blob' }
  );
}

  downloadJsonFile(checkedIds: any, isPreview: any) {
    let stTimeZone = CommonFunction.GetTimeZone();
    const body: any = {
      stcheckedIds: checkedIds,
      stTimeZone: stTimeZone,
      isPreview: isPreview,
    }
    return this.http.post(environment.WebApiURL + 'api/ClaimMonitor/GetClaimDetails', body);
  }

  downloadRawReportFile(checkedIds: any, claimIterationIds : any,objClaimPublish:any) {
    let stTimeZone = CommonFunction.GetTimeZone();
    const body: any = {
      stClaimMonitorIds: checkedIds,
      stClaimIterationIds: claimIterationIds,
      stTimeZone: stTimeZone,
      stClaimGroupId: objClaimPublish
    }
    return this.http.post(environment.WebApiURL + 'api/ClaimMonitor/downloadRawReportFile', body);
  }

  AddDownloadClaimLog(data: any): Observable<any> {
    this.loCurrentUserData = JSON.parse(localStorage.getItem('currentUserData') || '{}');
    const body: any = {
      uiLogBy: data.uiLogBy,
      uiActionId: data.uiActionId,
      uiTypeId: data.uiTypeId,
      inTypeNameId: data.inTypeNameId
    }
    return this.http.post(`${environment.WebApiURL}api/ClaimMonitor/AddDownloadClaimLog`, body).pipe(map((response: any) => {
      return response
    }));
  }

  getClaimMonitorDetailsReview(body: any): Observable<any> {
    return this.http.post(`${environment.WebApiURL}api/ClaimMonitor/GetClaimMonitorDetailsReview`, body).pipe(map((response: any) => {
      return response
    }));
  }

  getClaimMonitorDetailsReviewFinalCount(body: any): Observable<any> {
    return this.http.post(`${environment.WebApiURL}api/ClaimMonitor/GetClaimMonitorDetailsReviewFinalCount`, body).pipe(map((response: any) => {
      return response
    }));
  }

  // Need to update method name
  IterationClaimDetail(inClaimMonitorId: any, inGroupNo?: number, claimDetailsAdded: boolean = false): Observable<any> {
    return this.http.get(environment.WebApiURL + 'api/ClaimMonitor/IterationClaimDetails?inClaimMonitorId=' + inClaimMonitorId + '&inGroupNo=' + inGroupNo + '&claimDetailsAdded=' + claimDetailsAdded).pipe(map((response: any) => {
      return response.data
    }));
  }

  // refreshClaimIdentity(uiclaimIterationReqId: any, stPlatform: any, inIdentityIteration: any): Observable<any> {
  //   return this.http.get(environment.WebApiURL + `api/ClaimMonitor/IterationClaimIdentity?uiclaimIterationReqId=${uiclaimIterationReqId}&stPlatform=${stPlatform}&inIdentityIteration=${inIdentityIteration}`).pipe(map((response: any) => {
  //     return response
  //   }));
  // }

  saveClaimsMonitoringDetails(claimsMonitoringBody: any): Observable<any> {
    return this.http.post(environment.WebApiURL + 'api/ClaimMonitor/UpdateClaimReport', claimsMonitoringBody).pipe(map((response: any) => {
      return response
    }));
  }

  saveTimeLineDetails(data: any): Observable<any> {
    return this.http.post(environment.WebApiURL + 'api/ClaimMonitor/SaveTimeLine', data).pipe(map((response: any) => {
      return response
    }));
  }

  SaveAuditClaim(AuditRequests: any): Observable<any> {
    const AuditRequest = AuditRequests?.[0] ?? AuditRequests;
    return this.http.post(environment.WebApiURL + 'api/ClaimMonitor/SaveAuditClaim', AuditRequest).pipe(map((response: any) => {
      return response
    }));
  }

  includeIdentity(inClaimMonitorId: any, inClaimIterationId: any, inClaimAdditionalIdentityId: any,groupNo :any): Observable<any> {
    const body: any = {
      inClaimMonitorId: inClaimMonitorId,
      inClaimIterationId: inClaimIterationId,
      inClaimAdditionalIdentityId: inClaimAdditionalIdentityId,
      groupNo : groupNo
    }
    return this.http.post(environment.WebApiURL + 'api/ClaimMonitor/IncludeAdditionalIdentity', body).pipe(map((response: any) => {
      return response
    }));
  } 

  ArchiveClaim(inClaimMonitorId: string): Observable<any> {
    const body: any = {
      inClaimMonitorId: inClaimMonitorId
    }
    return this.http.post(`${environment.WebApiURL}api/ClaimMonitor/Archive`, body).pipe(map((response: any) => {
      return response
    }));
  }

  StopMonitoring(inClaimMonitorId: string): Observable<any> {
    const body: any = {
      inClaimMonitorId: inClaimMonitorId
    }
    return this.http.post(`${environment.WebApiURL}api/ClaimMonitor/StopMonitoring`, body).pipe(map((response: any) => {
      return response
    }));
  }

  RestoreClaim(inClaimMonitorId: string): Observable<any> {
    const body: any = {
      inClaimMonitorId: inClaimMonitorId
    }
    return this.http.post(`${environment.WebApiURL}api/ClaimMonitor/RestoreClaim`, body).pipe(map((response: any) => {
      return response
    }));
  }


  UnlockClaimFinding(Body: any): Observable<any> {
    return this.http.post(environment.WebApiURL + 'api/ClaimMonitor/UnlockClaimFinding', Body).pipe(map((response: any) => {
      return response
    }));
  }

  UnlockClaimIdentity(Body: any): Observable<any> {
    return this.http.post(environment.WebApiURL + 'api/ClaimMonitor/UnlockClaimIdentity', Body).pipe(map((response: any) => {
      return response
    }));
  }

  publishClaim(publishClaimBody: any): Observable<any> {
    return this.http.post(environment.WebApiURL + 'api/ClaimMonitor/UpdateClaimPublished', publishClaimBody).pipe(map((response: any) => {
      return response
    }));
  }

  approveClaimDetails(publishClaimBody: any): Observable<any> {
    return this.http.post(environment.WebApiURL + 'api/ClaimMonitor/ApproveClaimDetails', publishClaimBody).pipe(map((response: any) => {
      return response
    }));
  }

  getClaimIteration(uiClaimMonitorRequestId: any, inClaimMonitorId: any): Observable<any> {
    let stTimeZone = CommonFunction.GetTimeZone();
    return this.http.get(`${environment.WebApiURL}api/ClaimMonitor/getClaimIterations?uiClaimMonitorRequestId=${uiClaimMonitorRequestId}&inClaimMonitorId=${inClaimMonitorId}&stTimeZone=${stTimeZone}`).pipe(map((response: any) => {
      return response.data
    }));
  }

  getClaimPublishDates(inClaimMonitorId: any, inClaimIterationId: any,isRequest: any =false): Observable<any> {
    let stTimeZone = CommonFunction.GetTimeZone();
    return this.http.get(`${environment.WebApiURL}api/ClaimMonitor/getClaimPublishDates?inClaimMonitorId=${inClaimMonitorId}&inClaimIterationId=${inClaimIterationId}&stTimeZone=${stTimeZone}&isRequest=${isRequest}`).pipe(map((response: any) => {
      return response.data
    }));
  }

  updateClaimByRefresh(requestedClaimIds: any) {
    return this.http.post(`${environment.WebApiURL}api/ClaimMonitor/RefreshDataInGCP`, requestedClaimIds).pipe(map((response: any) => {
      return response.data;
    }));
  }

  getClaimReviewTimelineDetails(inClaimMonitorId: any, inClaimIterationId: any = 0): Observable<any> {
    let stTimeZone = CommonFunction.GetTimeZone();
    return this.http.get(`${environment.WebApiURL}api/ClaimMonitor/getClaimReviewTimeLineDetails?inClaimMonitorId=${inClaimMonitorId}&inClaimIterationId=${inClaimIterationId}&stTimeZone=${stTimeZone}`).pipe(map((response: any) => {
      return response.data
    }));
  }

  getClaimPreviewTimeLineDetails(inClaimMonitorId: any, inClaimIterationId: any = 0): Observable<any> {
    let stTimeZone = CommonFunction.GetTimeZone();
    return this.http.get(`${environment.WebApiURL}api/ClaimMonitor/getClaimPreviewTimelineDetails?inClaimMonitorId=${inClaimMonitorId}&inClaimIterationId=${inClaimIterationId}&stTimeZone=${stTimeZone}`).pipe(map((response: any) => {
      return response.data
    }));
  }

  saveimage(data: any): Observable<any> {
    return this.http.post(`${environment.WebApiURL}api/ClaimMonitor/saveCanvasImage`, data).pipe(map((response: any) => {
      return response
    }));
  }

  deleteImages(data: any): Observable<any> {
    return this.http.post(`${environment.WebApiURL}api/ClaimMonitor/deleteEditedImage`, data).pipe(map((response: any) => {
      return response
    }));
  }

  getImageAsBase64(url: string): Observable<string> {
    // Send the image URL as JSON payload
    const payload = { imageUrl: url };
  
    return this.http.get(`${environment.WebApiURL}api/ClaimMonitor/getBase64URL?url=${url}`).pipe(map((response: any) => {
      return response
    }));

  }

  private blobToBase64(blob: Blob): Observable<string> {
    return new Observable<string>((observer) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        observer.next(reader.result as string);
        observer.complete();
      };
      reader.onerror = (error) => observer.error(error);
      reader.readAsDataURL(blob);
    });
  }

  getGuacamoleConnectionDetails(platform: any, platformURL: any): Observable<any> {
    const payload = { platform: platform };
  
    return this.http.get(`${environment.WebApiURL}api/Guacamole/requestGuacamoleConnection?platform=${platform}&platformURL=${platformURL}`).pipe(map((response: any) => {
      return response
    }));
  }

  retraceClaim(inClaimMonitorId: string,inClaimIterationId: string): Observable<any> {
    const body: any = {
      inClaimMonitorId: inClaimMonitorId,
      inClaimIterationId:inClaimIterationId
    }
    return this.http.post(`${environment.WebApiURL}api/ClaimMonitor/RetraceClaimDetails`, body).pipe(map((response: any) => {
      return response
    }));
  }

  declineRequest(data :any): Observable<any> {
    return this.http.post(`${environment.WebApiURL}api/ClaimMonitor/addClaimDecline`, data).pipe(map((response: any) => {
      return response
    }));
  }


  captureScreenshot1(profile_url: string, platform: string, uiClaimMonitorRequestId: string, sectionName: string, uiClientId: string, inClaimIterationId: string, publishGroup?: string, reportHistoryDate?: string): Observable<any> {
    const requestBody: any = {
      profile_url: profile_url,
      platform: platform,
      identifier: uiClaimMonitorRequestId,
      platform_section: sectionName,
      uiClientId: uiClientId,
      inClaimIterationId: inClaimIterationId,
    }
    if (publishGroup != null) {
      requestBody.publishGroup = publishGroup;
    }
    if (reportHistoryDate != null) {
      requestBody.reportHistoryDate = reportHistoryDate;
    }
    // Set timeout to 10 minutes (600000 ms) for WebPageCapture API
    const TIMEOUT_DURATION = 600000; // 10 minutes in milliseconds
    return this.http.post(`${environment.WebApiURL}api/WebPageCapture`, requestBody).pipe(
      timeout(TIMEOUT_DURATION),
      catchError((error) => {
        if (error?.name === 'TimeoutError') {
          console.error('WebPageCapture API timeout after 5 minutes:', error);
          return throwError(() => new Error('Request timeout: The screenshot capture is taking longer than expected. Please try again.'));
        }
        // Handle other errors (like 504 Gateway Timeout)
        if (error?.status === 504) {
          console.error('WebPageCapture API Gateway Timeout (504):', error);
          return throwError(() => new Error('Gateway timeout: The server is taking too long to respond. Please try again.'));
        }
        return throwError(() => error);
      }),
      map((response: any) => {
        return{
          screenshotUrl: response.data.screenshot_url,
          shortenhashUrl: response.data.shorten_hash_url,
          shortenhashPdfUrl: response.data.shorten_hash_pdf_url
        }
      })
    );
  }
  captureScreenshot(profile_url: string, platform: string, uiClaimMonitorRequestId: string, sectionName: string, uiClientId: string, inClaimIterationId: string, publishGroup?: string, reportHistoryDate?: string): Observable<any> {
  
    const requestBody: any = {
      profile_url,
      platform,
      identifier: uiClaimMonitorRequestId,
      platform_section: sectionName,
      uiClientId,
      inClaimIterationId
    };
  
    if (publishGroup) requestBody.publishGroup = publishGroup;
    if (reportHistoryDate) requestBody.reportHistoryDate = reportHistoryDate;
  
    return this.http.post(
      `${environment.WebApiURL}api/WebPageCapture`,
      requestBody,
      {
        observe: 'events',       // prevents browser timeout
        reportProgress: true,      // keeps connection alive
        responseType: 'json'       // important for parsing body
      }
    ).pipe(
      filter((event: any) => event.type === HttpEventType.Response),
      map((event: any) => {
        const response = event.body;
        if (response == null) {
          throw new Error('WebPageCapture: empty response body');
        }
        const sc = response.statusCode ?? response.StatusCode;
        if (sc != null && Number(sc) >= 400) {
          const msg =
            (typeof response.message === 'string' && response.message) ||
            (typeof response.Message === 'string' && response.Message) ||
            'WebPageCapture request failed';
          throw new Error(msg);
        }
        const data = response.data;
        const screenshotUrl = data?.screenshot_url;
        if (screenshotUrl == null || String(screenshotUrl).trim() === '') {
          const msg =
            (typeof response.message === 'string' && response.message) ||
            (typeof response.Message === 'string' && response.Message) ||
            'WebPageCapture did not return an image URL';
          throw new Error(msg);
        }
        return {
          screenshotUrl,
          shortenhashUrl: data?.shorten_hash_url,
          shortenhashPdfUrl: data?.shorten_hash_pdf_url
        };
      })
    );
  }
  

  getAddressSuggestions(input: string): Observable<string[]> {
    return this.http.get<string[]>(`${environment.WebApiURL}api/Guacamole/getAddress?input=${encodeURIComponent(input)}`);
  }

  getAddressScreenshots(request_id: string, address: string): Observable<any>{
    const requestbody={
      address: address,
      request_id: request_id
    }
    return this.http.post(`${environment.WebApiURL}api/Utility/CaptureAddressScreenshots`, requestbody).pipe(
      map((response: any) => {
        if(!response || !response.data) return {};
        const { map_view, view_across} = response.data;
        return{
          map_view,
          ...(view_across || {})
        };
      })
    )
  }
  
  captureScreenshotWithPDF(url: string): Observable<any> {
   const body = { url: url };
   // Set timeout to 5 minutes (300000 ms) for webPageCapturePDF API
   const TIMEOUT_DURATION = 300000; // 5 minutes in milliseconds
   return this.http.post(`${environment.WebApiURL}api/ClaimMonitor/webPageCapturePDF`, body).pipe(
     timeout(TIMEOUT_DURATION),
     catchError((error) => {
       if (error instanceof TimeoutError) {
         console.error('webPageCapturePDF API timeout after 5 minutes:', error);
         return throwError(() => new Error('Request timeout: The PDF capture is taking longer than expected. Please try again.'));
       }
       // Handle other errors (like 504 Gateway Timeout)
       if (error.status === 504) {
         console.error('webPageCapturePDF API Gateway Timeout (504):', error);
         return throwError(() => new Error('Gateway timeout: The server is taking too long to respond. Please try again.'));
       }
       return throwError(() => error);
     }),
     map((response: any) => {
       return response;
     })
   );
 }

 downloadScraperFile(platform: any, platformURL: any, requestid: string, dtClaimFile: string, userId: string){
  return this.http.get(
    `${environment.WebApiURL}api/Guacamole/requestPlatformData?platform=${platform}&platformURL=${platformURL}&requestid=${requestid}&dtCutoffDate=${dtClaimFile}&uiUserId=${userId}`
  ).pipe(
    map((response: any) => {
      console.log("API Response:", response);
      return response.data;
    })
  );
}

  EnableDisableDailyMonitoring(inClaimMonitorId: string,isDailyMonitoring:boolean): Observable<any> {
   const body: any = {
     inClaimMonitorId: inClaimMonitorId,
     isDailyMonitoring: isDailyMonitoring
   }
   return this.http.post(`${environment.WebApiURL}api/ClaimMonitor/EnableDisableDailyMonitoring`, body).pipe(map((response: any) => {
     return response
   }));
 }

}

export const arrRiskType: any = {
  Low: 1,
  Medium: 2,
  High: 3,
  Error: 4
};

export const publishRiskType: any = {
  Low: 1,
  Medium: 2,
  High: 3
};

export const confidenceScoreType: any = {
  // Low: "Low",
  // Medium: "Medium",
  // High: "High"
  "0 of 6":"0 of 6",
  "0.5 of 6":"0.5 of 6",
  "1 of 6":"1 of 6",
  "1.5 of 6":"1.5 of 6",
  "2 of 6":"2 of 6",
  "2.5 of 6":"2.5 of 6",
  "3 of 6":"3 of 6",
  "3.5 of 6":"3.5 of 6",
  "4 of 6":"4 of 6",
  "4.5 of 6":"4.5 of 6",
  "5 of 6": "5 of 6",
  "5.5 of 6": "5.5 of 6",
  "6 of 6":"6 of 6"
};

export const socialMediaType: any = {
  Facebook: "Facebook",
  Instagram: "Instagram",
  X: "X",
  LinkedIn: "LinkedIn",
  Strava: "Strava",
  Spokeo: "Spokeo",
  Youtube: "Youtube",
  //Twitch: "Twitch",
  Snapchat: "Snapchat",
  Tumblr: "Tumblr",
  TikTok: "TikTok",
  //Soundcloud: "Soundcloud",
  //MapMyFitness: "MapMyFitness",
  Google: "Google",
  Flickr: "Flickr",
  Fitbit: "Fitbit",
  Radaris: "Radaris",
  Legal: "Legal",
  //Unmask: "Unmask",
  Reddit: "Reddit",
  Pinterest: "Pinterest",
  Arrests:"Arrests",
  TruePeopleSearch:"TruePeopleSearch",
  Pacer: "Pacer"
};

export const lstFindingSocialMediaType: any = {
  Facebook: "Facebook",
  Instagram: "Instagram",
  X: "X",
  LinkedIn: "LinkedIn",
  Strava: "Strava",
  Spokeo: "Spokeo",
  Youtube: "Youtube",
  //Twitch: "Twitch",
  Snapchat: "Snapchat",
  Tumblr: "Tumblr",
  TikTok: "TikTok",
  //Soundcloud: "Soundcloud",
  //MapMyFitness: "MapMyFitness",
  Google: "Google",
  Flickr: "Flickr",
  Fitbit: "Fitbit",
  Radaris: "Radaris",
  Legal: "Legal",
  //Unmask: "Unmask",
  Reddit: "Reddit",
  Pinterest: "Pinterest",
  TruePeopleSearch:"TruePeopleSearch",
  Pacer: "Pacer"
};

export const arrPhyLimitationType: any = {
  1: "Class 1",
  2: "Class 2",
  3: "Class 3",
  4: "Class 4",
  5: "Class 5",
};

export function enterKeyByDOM() {
  document.addEventListener('keydown', handleEnterKey);
}

export const handleEnterKey = (event: KeyboardEvent) => {
  if (event.key === 'Enter') {
    event.preventDefault();
  }
}

export const arrActivityLevel: any = {
  1: 'Active',
  2: 'Inactive',
  4: 'Very active'
};

// Enum for checkboxes
export enum IdentityCheckBoxFields {
  Name = 1,
  Age = 2,
  Gender = 4,
  Location = 3,
  Handle =5,
  Description = 6
}